const toggleFullWidthForm = () => {
    const form = document.querySelector('#full-width-form');
    form.classList.toggle('hide')
}

// ---------- Slick Sliders ---------- //
//Header Mobile - USPS
$(document).ready(function(){
    jQuery('.nav-usps-mobile-thin-slider').not('.slick-initialized').slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

$(document).ready(function(){
    jQuery('.nav-usps-mobile-slider').not('.slick-initialized').slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1, 
        slidesToScroll: 1
    });
});

//Header Marquee Slider
$(document).ready(function(){
    jQuery('.header-marquee-slider').not('.slick-initialized').slick({
        infinite: true,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Header Message Bar Slider
// $(document).ready(function(){
//     jQuery('.header-message-bar').not('.slick-initialized').slick({
//         infinite: true,
//         arrows: false,
//         fade: true,
//         autoplay: true,
//         autoplaySpeed: 2000,
//         speed: 5000,
//         slidesToShow: 1,
//         slidesToScroll: 1
//     });
// });

//Header Marquee Slider Mobile
$(document).ready(function(){
    jQuery('.header-marquee-slider-mobile').not('.slick-initialized').slick({
        infinite: true,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Index Main Slider
$(document).ready(function(){
    jQuery('.index-slider').not('.slick-initialized').slick({
        dots: true,
        appendDots: '.index-dots',
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: false,
        fade: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear'
    });
});

//Index Main Slider
$(document).ready(function(){
    jQuery('.index-slider-new').not('.slick-initialized').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        cssEase: 'linear'
    });
});

//Index Side Slider
$(document).ready(function(){
    jQuery('.index-slider-side').not('.slick-initialized').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        //dots: true,
        cssEase: 'linear'
    });
});



//Index Product Slider
$(document).ready(function(){
    jQuery('.index-slider-product').not('.slick-initialized').slick({
        infinite: true,
        arrows: true,
        prevArrow: $('.index-slider-product-prev'),
        nextArrow: $('.index-slider-product-next'),
        fade: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false
    });
});

//Showroom Slider
$(document).ready(function(){
    jQuery('.showroom-slider').not('.slick-initialized').slick({
        slide: '.showroom-slide',
        infinite: true,
        arrows: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Category Form Slider 
$(document).ready(function(){
    jQuery('.category-form-slider').not('.slick-initialized').slick({
        infinite: false,
        arrows: true,
        fade: true,
        draggable: false,
        prevArrow: $('.form-prev'),
        nextArrow: $('.form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Blod Header Slider
// $(document).ready(function(){
//     jQuery('#blog-dd-carousel').not('.slick-initialized').slick({
//         infinite: true,
//         arrows: false,
//         dots: false,
//         autoplay: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//     });
// });



//Pop Up Form Generic Slider
$(document).ready(function () {
    jQuery('.pop-up-form-generic-slider').not('.slick-initialized').slick({
        infinite: false,
        arrows: true,
        fade: true,
        draggable: false,
        touchMove: false,
        swipe: false,
        prevArrow: $('.pop-up-form-generic .form-prev'),
        nextArrow: $('.pop-up-form-generic .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Generic Exit Intent Slider
$(document).ready(function () {
    jQuery('.pop-up-form-generic-exit-slider').not('.slick-initialized').slick({
        infinite: false,
        arrows: true,
        fade: true,
        draggable: false,
        swipe: false,
        prevArrow: $('.pop-up-form-generic-exit .form-prev'),
        nextArrow: $('.pop-up-form-generic-exit .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Scooter Slider
$(document).ready(function () {
    jQuery('.pop-up-form-scooter-slider').not('.slick-initialized').slick({
        infinite: false,
        arrows: true,
        fade: true,
        draggable: false,
        swipe: false,
        prevArrow: $('.pop-up-form-scooter .form-prev'),
        nextArrow: $('.pop-up-form-scooter .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Chair Slider
$(document).ready(function () {
    jQuery('.pop-up-form-chair-slider').not('.slick-initialized').slick({
        infinite: false,
        arrows: true,
        fade: true,
        draggable: false,
        swipe: false,
        prevArrow: $('.pop-up-form-chair .form-prev'),
        nextArrow: $('.pop-up-form-chair .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Bed Slider
$(document).ready(function () {
    jQuery('.pop-up-form-bed-slider').not('.slick-initialized').slick({
        infinite: false,
        arrows: true,
        fade: true,
        draggable: false,
        swipe: false,
        prevArrow: $('.pop-up-form-bed .form-prev'),
        nextArrow: $('.pop-up-form-bed .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Product Page Slider
jQuery('.product-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '.product-slider-arrow-prev',
    nextArrow: '.product-slider-arrow-next',
    fade: true,
    asNavFor: '.product-slider-nav'
});

//Nav for Product Page Slider
jQuery('.product-slider-nav').not('.slick-initialized').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-slider',
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true,
    arrows: false
});

//Product Offer Slider
jQuery('.product-offer-slider').not('.slick-initialized').slick({
    fade: true,
    autoplay: true,
    arrows: false
});

//British Made Slider
$(document).ready(function(){
    jQuery('.british-made-slider-init').not('.slick-initialized').slick({
        dots: true,
        appendDots: '.british-made-dots',
        appendArrows: '.british-made-arrows',
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: true,
        fade: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear'
    });
});

//British Made Slider
$(document).ready(function(){
    jQuery('.our-values-slider-init').not('.slick-initialized').slick({
        dots: true,
        appendDots: '.british-made-dots',
        appendArrows: '.british-made-arrows',
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: true,
        fade: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear'
    });
});

$(document).ready(function(){
    jQuery('.cc-reviews-carousel').not('.slick-initialized').slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
    });
});
// Mattress Description Slider
$(document).ready(function(){
    jQuery('#mattress-description-slide').not('.slick-initialized').slick({
        infinite: true,
        // appendArrows: '.button-wrapper',
        prevArrow: '.mattress-button-prev',
        nextArrow: '.mattress-button-next',
        swipe: false,
        arrows: true,
        dots: true,
        dotsClass: 'mattress-slick-dots',
        appendDots: '.specification-mattress-grid-new',
        draggable: false,
        autoplay: false,
    });
}); 
// Scooting Landing slider
$(document).ready(function(){
    jQuery('#scooter-reasons-slick').not('.slick-initialized').slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: '#scooter-reasons-dots',
        draggable: true,
        autoplay: true,
        settings: 'unslick',
        responsive: [
            {
                breakpoint: 2400,
                settings: 'unslick'
              },
              {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
              }
          ]
    });
});

//Store Reviews Slider
$(document).ready(function () {
    jQuery('#store-reviews-carousel').not('.slick-initialized').slick({
        infinite: true,
        arrows: false,
        fade: true,
        draggable: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: '#carousel-dots-store-reviews',
        dotsClass: 'dots'
    });
});



// Chair Landing reasons
jQuery('#chair-reasons-slick').not('.slick-initialized').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    appendDots: '#chair-reasons-dots',
    draggable: true,
    autoplay: false,
    settings: 'unslick',
    responsive: [
        {
            breakpoint: 2400,
            settings: 'unslick'
          },
          {
            breakpoint: 800,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
          }
      ]
});

function reportWindowSize() {
        $(document).ready(function(){ 
            jQuery('#chair-reasons-slick').not('.slick-initialized').slick({
                infinite: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendDots: '#chair-reasons-dots',
                draggable: true,
                autoplay: false,
                settings: 'unslick',
                responsive: [
                    {
                        breakpoint: 10000,
                        settings: 'unslick'
                      },
                      {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                          }
                      }
                  ]
            });

            jQuery('#bed-reasons-slick').not('.slick-initialized').slick({
                infinite: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendDots: '#scooter-reasons-dots',
                draggable: true,
                autoplay: false,
                settings: 'unslick',
                responsive: [
                    {
                        breakpoint: 2400,
                        settings: 'unslick'
                      },
                      {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                          }
                      }
                  ]
            });
        });
    
}

window.onresize = reportWindowSize;

$(document).ready(function(){
    jQuery('#chair-reviews').not('.slick-initialized').slick({
        infinite: false,
        centerMode: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        appendDots: '.chair-reviews-dots',
        arrows: false,
        autoplay: false,
        responsive : [
            {
                breakpoint: 1060,
                settings: {
                    // infinite: false,
                    arrows: false,
                    centerMode: true,
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
});
$(document).ready(function(){
    jQuery('#chair-mobile-reviews').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        nextArrow: '#mob-reviews-chair-next',
        prevArrow: '#mob-reviews-chair-prev',
        arrows: true,
    });
});
$(document).ready(function(){
    jQuery('#chair-mobile-reviews-v2').not('.slick-initialized').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: '#mob-reviews-chair-next',
        prevArrow: '#mob-reviews-chair-prev',
        arrows: true,
    });
});

//Landing Store Gallery 
$(document).ready(function(){
    jQuery('.landing-store-gallery').not('.slick-initialized').slick({
        infinite: true,
        arrows: true,
        prevArrow: $('#landing-gallery-prev'),
        nextArrow: $('#landing-gallery-next'),
        slidesToShow: 1,
        slidesToScroll: 1
    });
});


$(document).ready(function(){
    jQuery('#scooter-story-tile').not('.slick-initialized').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        appendDots: '#scooter-story-dots',
        responsive: [
            {
              breakpoint: 890,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
      });
}); 



  const settings = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    dots: true,
    appendDots: '.other-dots-wrapper',
    // mobileFirst:true,
    responsive: [
        {
            breakpoint: 9999,
            settings:'unslick'
        },
        {
            breakpoint: 930,
             settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
        },
        {
            breakpoint: 550,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
        }
    ]
  }

  $('.other-col-grid').slick(settings);
  const sl =  document.querySelector('.other-col-grid')
  $(window).on('resize', function() {
    if(sl !== null) {
        if( $(window).width() < 931 && !sl.classList.contains('slick-initialized'))  {
            $('.other-col-grid').slick(settings);
        }
    }
 });

 const settingsIndexCat = {
    infinite: false,
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll:2,
    appendDots: '.carousel-dots-index-scooter',
    // initialSlide: 1,
    responsive: [
        {
            breakpoint: 830,
             settings: {
                    slidesToShow: 2,
                    slidesToScroll:2,
                    infinite: false,
                    dots: true
                }
        },
        {
            breakpoint: 550,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                    infinite: false,
                    dots: true
                }
        }
    ]
  }
 const settingsIndexCatChair = {
    infinite: false,
    arrows: false,
    dots: true,
    appendDots: '.carousel-dots-index-chair',
    // initialSlide: 1,
    responsive: [
        {
            breakpoint: 9999,
            settings:'unslick'
        },
        {
            breakpoint: 830,
             settings: {
                    slidesToShow: 2,
                    slidesToScroll:1,
                    infinite: false,
                    dots: true
                }
        },
        {
            breakpoint: 550,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                    infinite: false,
                    dots: true
                }
        }
    ]
  }
 const settingsIndexCatBed = {
    infinite: false,
    arrows: false,
    dots: true,
    appendDots: '.carousel-dots-index-bed',
    // initialSlide: 1,
    responsive: [
        {
            breakpoint: 9999,
            settings:'unslick'
        },
        {
            breakpoint: 830,
             settings: {
                    slidesToShow: 2,
                    slidesToScroll:1,
                    infinite: false,
                    dots: true
                }
        },
        {
            breakpoint: 550,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                    infinite: false,
                    dots: true
                }
        }
    ]
  }

  

// get slide of slides for slick slides (Index Product Slider)
$(document).ready(function(){
    var $statusSlide = $('.status-slide');
    var $statusOf = $('.status-of');
    var $slickElement = $('.index-slider-product');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        if(i > 3 ) i = 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

$('#index-scooter-category').slick(settingsIndexCat);
$('#index-chair-category').slick(settingsIndexCatChair);
$('#index-bed-category').slick(settingsIndexCatBed);

const sl2 =  document.querySelector('#index-scooter-category')
const sl3 =  document.querySelector('#index-chair-category')
const sl4 =  document.querySelector('#index-bed-category')

$(window).on('resize', function() {
    if(sl2 !== null) { 
        let isInit = sl2.classList.contains('slick-initialized');
        if(isInit !== null ){
            $('.index-slider-product')[0].slick.refresh();
            // $('#index-scooter-category').slick('setPosition');
            if($(window).width() < 1258 && !sl2.classList.contains('slick-initialized') )  {
                $('#index-scooter-category').slick(settingsIndexCat);
            } 
            if($(window).width() < 830 && !sl3.classList.contains('slick-initialized') )  {
                $('#index-chair-category').slick(settingsIndexCatChair);
                $('#index-bed-category').slick(settingsIndexCatBed);
            } 
        }
    }
 });

// get slide of slides for slick slides (Category Form)
$(document).ready(function(){
    var $statusSlide = $('.status-slide');
    var $statusOf = $('.status-of');
    var $slickElement = $('.category-form-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Generic Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-generic-pop-up');
    var $statusOf = $('.status-of-generic-pop-up');
    var $slickElement = $('.pop-up-form-generic-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });


});

// get slide of slides for slick slides (Pop Up Generic Exit Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-generic-exit-pop-up');
    var $statusOf = $('.status-of-generic-exit-pop-up');
    var $slickElement = $('.pop-up-form-generic-exit-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Scooter Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-scooter-pop-up');
    var $statusOf = $('.status-of-scooter-pop-up');
    var $slickElement = $('.pop-up-form-scooter-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Chair Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-chair-pop-up');
    var $statusOf = $('.status-of-chair-pop-up');
    var $slickElement = $('.pop-up-form-chair-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Bed Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-bed-pop-up');
    var $statusOf = $('.status-of-bed-pop-up');
    var $slickElement = $('.pop-up-form-bed-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// Progress bar (Category Form)
$(document).ready(function() {
    var $slider = $('.category-form-slider');
    var $progressBar = $('.progress');
    
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      
      $progressBar
        .css('background-size', calc +  '% 100%')
        .attr('aria-valuenow', calc );
      
    });
});

// Progress bar (Pop Up Generic Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-generic-slider');
    var $progressBar = $('.progress-generic-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// Progress bar (Pop Up Generic Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-generic-exit-slider');
    var $progressBar = $('.progress-generic-exit-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    }); 
});

// Progress bar (Pop Up Scooter Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-scooter-slider');
    var $progressBar = $('.progress-scooter-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// Progress bar (Pop Up Chair Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-chair-slider');
    var $progressBar = $('.progress-chair-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// Progress bar (Pop Up Bed Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-bed-slider');
    var $progressBar = $('.progress-bed-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});


$(document).ready(function(){
    jQuery('#index-aside-carousel').not('.slick-initialized').slick({
        dots: false,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 7000,
        infinite: true,
        fade: false,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        fade: true,
        adaptiveHeight: true
    });
});


// ---------- Pop Up Forms ---------- //
// Generic
$(document).ready(function () {
    $("#main-header-brochure, #core-ctas-brochure-request, #sticky-bar-brochure, #mobile-brochure-header, #mobile-brochure-header-bar,  #mobile-brochure-header-bar-2, #mini-bar-brochure, #popular-search-brochure, #drop-down-menu-cta-button-brochure, #cabin-car-hero-brochure, #cabin-car-brochure, #cabin-car-closer-look-brochure, #cabin-car-banner-btn, #cc-request-brochure-bottom, #offers-page-brochure, #offers-scooter-brochure, #offers-bed-brochure, #offers-chair-brochure, #main-offer-btn-1, #main-offer-btn-2, #article-brochure-request").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-generic").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on"); 
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-generic-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-generic").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

//Generic from mobile menu
$(document).ready(function () {
    $("#side-nav-brochure-request").on("click", function (e) {
        e.preventDefault();
        $("#side-nav-main").removeClass("side-nav-open");
        $("#side-nav-main").addClass("side-nav-closed");
        $("#side-nav-close").addClass("hide");
        $("#pop-up-form-generic").addClass("modal-pop-show");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

///Scooter
$(document).ready(function () {
    $("#category-brochure-button-mobile-scooter, #product-scooter-brochure, #sticky-bar-brochure-scooter").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-scooter").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-scooter-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-scooter").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

///Chair
$(document).ready(function () {
    $("#category-brochure-button-mobile-chair, #product-chair-brochure, #landing-chair-hero-cta, #landing-chair-cta-usps-desktop, #landing-chair-cta-usps-mobile, #landing-chair-cta-ready-to-order, #sticky-bar-brochure-chair, #tab-request-brochure-chair, #chair-basket-request-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-chair").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-chair-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-chair").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

///Bed
$(document).ready(function () {
    $("#category-brochure-button-mobile-bed, #product-bed-brochure, #sticky-bar-brochure-bed, #tab-request-brochure-bed, #bed-basket-request-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-bed").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-bed-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-bed").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});


///Exit Intent Pop Up =  Other code moved to footer for A/B test on optimize
setTimeout(() => {
    $(document).on("mouseout", evt => {
        if(window.location.href.includes('request-our') || window.location.href.includes('/pages/thank-you-brochure') || window.location.href.includes('/pages/store-appointment') || window.location.href.includes('/pages/home-appointment') || window.location.href.includes('/pages/user-locator')) {
            return;
        } else {
            if(document.cookie.match(/^(.*;)?\s*exitIntent\s*=\s*[^;]+(.*)?$/) === null) {
                if(evt.toElement === null && evt.relatedTarget === null) {
                    $(evt.currentTarget).off("mouseout");
                    // An intent to exit has happened
                    $("#pop-up-form-generic-exit").addClass("modal-pop-show");
                    $("#pop-up-fabrics-chair").removeClass("modal-pop-show");
                    $("#lights-out").addClass("lights-out-on");
                    $("body").addClass("active-menu");
                    $("#prevent-scrolling").addClass("prevent-scrolling");
                }
            } 
        }
    });
}, 2000); 

$(document).ready(function () {
    $("#pop-up-form-generic-exit-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-generic-exit").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
        document.cookie = "exitIntent=Yes; path=/";
    });
});


///Pop Up Out of Area Store

//(only close is here as this is triggered in jquery.storelocator.js file)
$(document).ready(function () {
    $("#pop-up-store-out-of-area-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-store-out-of-area").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

///Pop Up Out of Area Store - go to brochure pop up
$(document).ready(function () {
    $("#pop-up-store-out-of-area-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-store-out-of-area").removeClass("modal-pop-show");
        $("#pop-up-form-generic").addClass("modal-pop-show");
    });
});

////Pop Up Vat Qualify on Product Page
$(document).ready(function () {
    $(".qualify, #qualify-note").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-vat-qualify").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-vat-qualify-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-vat-qualify").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});


////Pop Up Fabrics Chair Product Page
$(document).ready(function () {
    $("#fabric-pop").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-fabrics-chair").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-fabrics-chair-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-fabrics-chair").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

////Request Brochure Button Within Fabric Pop Up
$(document).ready(function () {
    $("#product-chair-fabric-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-fabrics-chair").removeClass("modal-pop-show");
        $("#pop-up-form-chair").addClass("modal-pop-show");

    });
});

////Pop Up Email Sign Up Form
$(document).ready(function () {
    $(".blog-sign-up").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-email-subscribe").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-email-subscribe-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-email-subscribe").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

////Pop Up Buy Online
$(document).ready(function () {
    $("#buy-online-button").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-buy-online").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-buy-online-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-buy-online").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

////Pop Up Chair Dimensions
$(document).ready(function () {
    $("#product-size-pop-trigger").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-chair-dimensions").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-chair-dimensions-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-chair-dimensions").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
        location.href = "#product-specification-anchor";
        
    });
});

////Pop Up Chair Covid
$(document).ready(function () {
    $("#covid-chair-pop").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-chair-covid").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-chair-covid-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-chair-covid").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

////Pop Up Try it Yourself
$(document).ready(function () {
    $("#product-try").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-try-it-yourself").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-try-it-yourself-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-try-it-yourself").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

//Disable Enter to send form without validation
$('#main-pop-up-form, #bed-pop-up-form, #chair-pop-up-form, #scooter-pop-up-form, #landing-category-bed-form, #landing-category-scooter-form, #landing-category-chair-form').on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) { 
      e.preventDefault();
      return false;
    }
});

// Close all pop up forms when bg clicked
$(document).ready(function () {
    $("#lights-out").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-generic, #pop-up-form-scooter, #pop-up-form-chair, #pop-up-form-bed, #pop-up-store-out-of-area, #pop-up-vat-qualify, #pop-up-fabrics-chair, #pop-up-email-subscribe, #pop-up-buy-online, #pop-up-chair-dimensions, #pop-up-chair-covid, #pop-up-try-it-yourself").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});


// ---------- Side Menu ---------- //
// Set height of mobile side nav to inner window - for iPhone 10, etc



// Side Menu Accordian
$(document).ready(function(){
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
        panel.style.maxHeight = null;
        } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        } 
    });
    }
});


// New Header - MEGA MENU //


// Main Nav Button to Drop Down Menus //
// Chairs //
$("#hover-chairs").hover(
    function () {
        $("#expand-chairs").addClass("expand-show");
        $("#hover-chairs").addClass("hover-chairs");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-chairs").removeClass("expand-show");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

$("#expand-chairs").hover(
    function () {
        $("#expand-chairs").addClass("expand-show");
        $("#hover-chairs").addClass("hover-chairs");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-chairs").removeClass("expand-show");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

// beds //
$("#hover-beds").hover(
    function () {
        $("#expand-beds").addClass("expand-show");
        $("#hover-beds").addClass("hover-beds");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-beds").removeClass("expand-show");
        $("#hover-beds").removeClass("hover-beds");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

$("#expand-beds").hover(
    function () {
        $("#expand-beds").addClass("expand-show");
        $("#hover-beds").addClass("hover-beds");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-beds").removeClass("expand-show");
        $("#hover-beds").removeClass("hover-beds");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

// scooters //
$("#hover-scooters").hover(
    function () {
        $("#expand-scooters").addClass("expand-show");
        $("#hover-scooters").addClass("hover-scooters");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-scooters").removeClass("expand-show");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

$("#expand-scooters").hover(
    function () {
        $("#expand-scooters").addClass("expand-show");
        $("#hover-scooters").addClass("hover-scooters");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-scooters").removeClass("expand-show");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

$("#expand-chairs").hover(
    function () {
        $("#expand-chairs").addClass("expand-show");
        $("#hover-chairs").addClass("hover-chairs");
        $("#lights-out-menu").addClass("lights-out-on");

    }, 
    function () {
        $("#expand-chairs").removeClass("expand-show");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#lights-out-menu").removeClass("lights-out-on");

    }
);

//      UPATED MEGAMENU      //
$("#hover-chairs").hover(
    function () {
        $("#expand-chairs").addClass("expand-show");
        $("#hover-chairs").addClass("hover-chairs");
        $("#lights-out-menu").addClass("lights-out-on");

        $("#chair-expand").removeClass("hide-expand-menu");
    }, 
    function () {
        $("#expand-chairs").removeClass("expand-show");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#lights-out-menu").removeClass("lights-out-on");

        $("#chair-expand").addClass("hide-expand-menu");
    }
);
$("#chair-expand").hover(
    function () {
        $("#chair-expand").removeClass("hide-expand-menu");
        $("#hover-chairs").addClass("hover-chairs");
        $("#lights-out-menu").addClass("lights-out-on");
    },
    function () {
        $("#chair-expand").addClass("hide-expand-menu");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#lights-out-menu").removeClass("lights-out-on");
    }
)

$("#hover-beds").hover(
    function () {
        $("#expand-beds").addClass("expand-show");
        $("#hover-beds").addClass("hover-beds");
        $("#lights-out-menu").addClass("lights-out-on");


        $("#bed-expand").removeClass("hide-expand-menu");
    }, 
    function () {
        $("#expand-beds").removeClass("expand-show");
        $("#hover-beds").removeClass("hover-beds");
        $("#lights-out-menu").removeClass("lights-out-on");

        $("#bed-expand").addClass("hide-expand-menu");
    }
);

$("#bed-expand").hover(
    function () {
        $("#bed-expand").removeClass("hide-expand-menu");
        $("#hover-beds").addClass("hover-beds");
        $("#lights-out-menu").addClass("lights-out-on");
    },
    function () {
        $("#bed-expand").addClass("hide-expand-menu");
        $("#hover-beds").removeClass("hover-beds");
        $("#lights-out-menu").removeClass("lights-out-on");
    }
)

$("#hover-scooters").hover(
    function () {
        $("#expand-scooters").addClass("expand-show")
        $("#hover-scooters").addClass("hover-scooters");
        $("#lights-out-menu").addClass("lights-out-on");

        $("#scooter-expand").removeClass("hide-expand-menu");

    }, 
    function () {
        $("#expand-scooters").removeClass("expand-show");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#lights-out-menu").removeClass("lights-out-on");

        $("#scooter-expand").addClass("hide-expand-menu");

    }
);
$("#scooter-expand").hover(
    function () {
        $("#scooter-expand").removeClass("hide-expand-menu");
        $("#hover-scooters").addClass("hover-scooters");
        $("#lights-out-menu").addClass("lights-out-on");
    },
    function () {
        $("#scooter-expand").addClass("hide-expand-menu");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#lights-out-menu").removeClass("lights-out-on");
    }
)

// Offers //
$("#hover-offers").hover(
    function () {
        $("#lights-out-menu").addClass("lights-out-on");
        $("#offers-expand").removeClass("hide-expand-menu");

    }, 
    function () {   
        $("#lights-out-menu").removeClass("lights-out-on");
        $("#offers-expand").addClass("hide-expand-menu");

    }
);

$("#offers-expand").hover(
    function () {
        $("#lights-out-menu").addClass("lights-out-on");
        $("#offers-expand").removeClass("hide-expand-menu");

    },
    function () {
        $("#lights-out-menu").removeClass("lights-out-on");
        $("#offers-expand").addClass("hide-expand-menu");
    }
)
// Help & Advice //
$("#hover-help").hover(
    function () {
        $("#hover-help").addClass("hover-help");
        $("#lights-out-menu").addClass("lights-out-on");
        $("#help-expand").removeClass("hide-expand-menu");

    }, 
    function () {   
        $("#hover-help").removeClass("hover-help");
        $("#lights-out-menu").removeClass("lights-out-on");
        $("#help-expand").addClass("hide-expand-menu");

    }
);

$("#help-expand").hover(
    function () {
        $("#hover-help").addClass("hover-help");
        $("#lights-out-menu").addClass("lights-out-on");
        $("#help-expand").removeClass("hide-expand-menu");

    },
    function () {
        $("#hover-help").removeClass("hover-help");
        $("#lights-out-menu").removeClass("lights-out-on");
        $("#help-expand").addClass("hide-expand-menu");
    }
)

// Changing Cotent on Inner Menus //
// Chairs //
$("#menu-item-chair-collections").hover(
    function () {
        $("#menu-item-chair-collections").addClass("menu-item-active");
        $("#menu-item-chair-why, #menu-item-chair-lifestyle, #menu-item-chair-offers").removeClass("menu-item-active");
        $("#expandable-chair-collections").addClass("expandable-cb-show");
        $("#expandable-chair-why, #expandable-chair-lifestyle, #expandable-chair-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-chair-collections").hover(
    function () {
        $("#expandable-chair-collections").addClass("expandable-cb-show");
        $("#expandable-chair-why, #expandable-chair-lifestyle, #expandable-chair-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-chair-why").hover(
    function () {
        $("#menu-item-chair-why").addClass("menu-item-active");
        $("#menu-item-chair-collections, #menu-item-chair-lifestyle, #menu-item-chair-offers").removeClass("menu-item-active");
        $("#expandable-chair-why").addClass("expandable-cb-show");
        $("#expandable-chair-collections, #expandable-chair-lifestyle, #expandable-chair-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-chair-why").hover(
    function () {
        $("#expandable-chair-why").addClass("expandable-cb-show");
        $("#expandable-chair-collections, #expandable-chair-lifestyle, #expandable-chair-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-chair-lifestyle").hover(
    function () {
        $("#menu-item-chair-lifestyle").addClass("menu-item-active");
        $("#menu-item-chair-why, #menu-item-chair-collections, #menu-item-chair-offers").removeClass("menu-item-active");
        $("#expandable-chair-lifestyle").addClass("expandable-cb-show");
        $("#expandable-chair-collections, #expandable-chair-why, #expandable-chair-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-chair-lifestyle").hover(
    function () {
        $("#expandable-chair-lifestyle").addClass("expandable-cb-show");
        $("#expandable-chair-collections, #expandable-chair-why, #expandable-chair-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-chair-offers").hover(
    function () {
        $("#menu-item-chair-offers").addClass("menu-item-active");
        $("#menu-item-chair-why, #menu-item-chair-lifestyle, #menu-item-chair-lifestyle").removeClass("menu-item-active");
        $("#expandable-chair-offers").addClass("expandable-cb-show");
        $("#expandable-chair-collections, #expandable-chair-why, #expandable-chair-lifestyle").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-chair-offers").hover(
    function () {
        $("#expandable-chair-offers").addClass("expandable-cb-show");
        $("#expandable-chair-collections, #expandable-chair-why, #expandable-chair-lifestyle").removeClass("expandable-cb-show");
    }, 
);

// Beds //
$("#menu-item-bed-collections").hover(
    function () {
        $("#menu-item-bed-collections").addClass("menu-item-active");
        $("#menu-item-bed-why, #menu-item-bed-lifestyle, #menu-item-bed-offers").removeClass("menu-item-active");
        $("#expandable-bed-collections").addClass("expandable-cb-show");
        $("#expandable-bed-why, #expandable-bed-lifestyle, #expandable-bed-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-bed-collections").hover(
    function () {
        $("#expandable-bed-collections").addClass("expandable-cb-show");
        $("#expandable-bed-why, #expandable-bed-lifestyle, #expandable-bed-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-bed-why").hover(
    function () {
        $("#menu-item-bed-why").addClass("menu-item-active");
        $("#menu-item-bed-collections, #menu-item-bed-lifestyle, #menu-item-bed-offers").removeClass("menu-item-active");
        $("#expandable-bed-why").addClass("expandable-cb-show");
        $("#expandable-bed-collections, #expandable-bed-lifestyle, #expandable-bed-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-bed-why").hover(
    function () {
        $("#expandable-bed-why").addClass("expandable-cb-show");
        $("#expandable-bed-collections, #expandable-bed-lifestyle, #expandable-bed-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-bed-lifestyle").hover(
    function () {
        $("#menu-item-bed-lifestyle").addClass("menu-item-active");
        $("#menu-item-bed-why, #menu-item-bed-collections, #menu-item-bed-offers").removeClass("menu-item-active");
        $("#expandable-bed-lifestyle").addClass("expandable-cb-show");
        $("#expandable-bed-collections, #expandable-bed-why, #expandable-bed-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-bed-lifestyle").hover(
    function () {
        $("#expandable-bed-lifestyle").addClass("expandable-cb-show");
        $("#expandable-bed-collections, #expandable-bed-why, #expandable-bed-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-bed-offers").hover(
    function () {
        $("#menu-item-bed-offers").addClass("menu-item-active");
        $("#menu-item-bed-why, #menu-item-bed-lifestyle, #menu-item-bed-lifestyle").removeClass("menu-item-active");
        $("#expandable-bed-offers").addClass("expandable-cb-show");
        $("#expandable-bed-collections, #expandable-bed-why, #expandable-bed-lifestyle").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-bed-offers").hover(
    function () {
        $("#expandable-bed-offers").addClass("expandable-cb-show");
        $("#expandable-bed-collections, #expandable-bed-why, #expandable-bed-lifestyle").removeClass("expandable-cb-show");
    }, 
);

// Scooters //
$("#menu-item-scooter-collections").hover(
    function () {
        $("#menu-item-scooter-collections").addClass("menu-item-active");
        $("#menu-item-scooter-why, #menu-item-scooter-lifestyle, #menu-item-scooter-offers").removeClass("menu-item-active");
        $("#expandable-scooter-collections").addClass("expandable-cb-show");
        $("#expandable-scooter-why, #expandable-scooter-lifestyle, #expandable-scooter-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-scooter-collections").hover(
    function () {
        $("#expandable-scooter-collections").addClass("expandable-cb-show");
        $("#expandable-scooter-why, #expandable-scooter-lifestyle, #expandable-scooter-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-scooter-why").hover(
    function () {
        $("#menu-item-scooter-why").addClass("menu-item-active");
        $("#menu-item-scooter-collections, #menu-item-scooter-lifestyle, #menu-item-scooter-offers").removeClass("menu-item-active");
        $("#expandable-scooter-why").addClass("expandable-cb-show");
        $("#expandable-scooter-collections, #expandable-scooter-lifestyle, #expandable-scooter-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-scooter-why").hover(
    function () {
        $("#expandable-scooter-why").addClass("expandable-cb-show");
        $("#expandable-scooter-collections, #expandable-scooter-lifestyle, #expandable-scooter-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-scooter-lifestyle").hover(
    function () {
        $("#menu-item-scooter-lifestyle").addClass("menu-item-active");
        $("#menu-item-scooter-why, #menu-item-scooter-collections, #menu-item-scooter-offers").removeClass("menu-item-active");
        $("#expandable-scooter-lifestyle").addClass("expandable-cb-show");
        $("#expandable-scooter-collections, #expandable-scooter-why, #expandable-scooter-offers").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-scooter-lifestyle").hover(
    function () {
        $("#expandable-scooter-lifestyle").addClass("expandable-cb-show");
        $("#expandable-scooter-collections, #expandable-scooter-why, #expandable-scooter-offers").removeClass("expandable-cb-show");
    }, 
);

$("#menu-item-scooter-offers").hover(
    function () {
        $("#menu-item-scooter-offers").addClass("menu-item-active");
        $("#menu-item-scooter-why, #menu-item-scooter-lifestyle, #menu-item-scooter-lifestyle").removeClass("menu-item-active");
        $("#expandable-scooter-offers").addClass("expandable-cb-show");
        $("#expandable-scooter-collections, #expandable-scooter-why, #expandable-scooter-lifestyle").removeClass("expandable-cb-show");
    }, 
);

$("#expandable-scooter-offers").hover(
    function () {
        $("#expandable-scooter-offers").addClass("expandable-cb-show");
        $("#expandable-scooter-collections, #expandable-scooter-why, #expandable-scooter-lifestyle").removeClass("expandable-cb-show");
    }, 
);





//



/*
// ---------- Slide Down Main Menu ---------- //
$("#hover-about").hover(
    function () {
        //$("#expand-about").addClass("vao");
        $("#hover-about").addClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").addClass("hide");
        $("#hover-about > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        //$("#expand-about").removeClass("vao");
        $("#hover-about").removeClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").removeClass("hide");
        $("#hover-about > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-about").hover(
    function () {
        $("#expand-about").addClass("vao");
        $("#hover-about").addClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").addClass("hide");
        $("#hover-about > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-about").removeClass("vao");
        $("#hover-about").removeClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").removeClass("hide");
        $("#hover-about > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-chairs").hover(
    function () {
        $("#expand-chairs").addClass("vao");
        $("#hover-chairs").addClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").addClass("hide");
        $("#hover-chairs > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-chairs").removeClass("vao");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").removeClass("hide");
        $("#hover-chairs > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-chairs").hover(
    function () {
        $("#expand-chairs").addClass("vao");
        $("#hover-chairs").addClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").addClass("hide");
        $("#hover-chairs > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-chairs").removeClass("vao");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").removeClass("hide");
        $("#hover-chairs > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-beds").hover(
    function () {
        $("#expand-beds").addClass("vao");
        $("#hover-beds").addClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").addClass("hide");
        $("#hover-beds > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-beds").removeClass("vao");
        $("#hover-beds").removeClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").removeClass("hide");
        $("#hover-beds > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-beds").hover(
    function () {
        $("#expand-beds").addClass("vao");
        $("#hover-beds").addClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").addClass("hide");
        $("#hover-beds > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-beds").removeClass("vao");
        $("#hover-beds").removeClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").removeClass("hide");
        $("#hover-beds > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-scooters").hover(
    function () {
        $("#expand-scooters").addClass("vao");
        $("#hover-scooters").addClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").addClass("hide");
        $("#hover-scooters > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-scooters").removeClass("vao");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").removeClass("hide");
        $("#hover-scooters > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-scooters").hover(
    function () {
        $("#expand-scooters").addClass("vao");
        $("#hover-scooters").addClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").addClass("hide");
        $("#hover-scooters > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-scooters").removeClass("vao");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").removeClass("hide");
        $("#hover-scooters > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-offers").hover(
    function () {
        //$("#expand-offers").addClass("vao");
        $("#hover-offers").addClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").addClass("hide");
        $("#hover-offers > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        //$("#expand-offers").removeClass("vao");
        $("#hover-offers").removeClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").removeClass("hide");
        $("#hover-offers > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-offers").hover(
    function () {
        //$("#expand-offers").addClass("vao");
        $("#hover-offers").addClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").addClass("hide");
        $("#hover-offers > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        //$("#expand-offers").removeClass("vao");
        $("#hover-offers").removeClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").removeClass("hide");
        $("#hover-offers > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-help").hover(
    function () {
        $("#expand-help").addClass("vao");
        $("#hover-help").addClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").addClass("hide");
        $("#hover-help > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-help").removeClass("vao");
        $("#hover-help").removeClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").removeClass("hide");
        $("#hover-help > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-help").hover(
    function () {
        $("#expand-help").addClass("vao");
        $("#hover-help").addClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").addClass("hide");
        $("#hover-help > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-help").removeClass("vao");
        $("#hover-help").removeClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").removeClass("hide");
        $("#hover-help > .nav-arrow-white").removeClass("show-arrow");
    }
);

*/ 

// ---------- Main Nav Menus ---------- //
//Open menu on menu button click
$(document).ready(function () {
	$("#nav-cta-mobile-menu").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-main").hasClass("side-nav-closed")) {
            $("#side-nav-main").addClass("side-nav-open");
            $("#side-nav-main").removeClass("side-nav-closed");
            $("#lights-out").addClass("lights-out-on");
            $("#side-nav-close").removeClass("hide");
            $("#prevent-scrolling").addClass("prevent-scrolling");
		}
		else if($("#side-nav-main").hasClass("open-slide")) {
			
		}
	});
});
//Open menu on menu button click
$(document).ready(function () {
	$("#nav-cta-mobile-menu-new").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-main").hasClass("side-nav-closed")) {
            $("#side-nav-main").addClass("side-nav-open");
            $("#side-nav-main").removeClass("side-nav-closed");
            $("#lights-out").addClass("lights-out-on");
            $("#side-nav-close").removeClass("hide");
            $("#prevent-scrolling").addClass("prevent-scrolling");
		}
		else if($("#side-nav-main").hasClass("open-slide")) {
			
		}
	});
});

//Close menu on 'x' button click
$(document).ready(function () {
	$("#side-nav-close").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-main").hasClass("side-nav-open")) {
            $("#side-nav-main").removeClass("side-nav-open");
            $("#side-nav-main").addClass("side-nav-closed");
            $("#lights-out").removeClass("lights-out-on");
            $("#side-nav-close").addClass("hide");
            $("#prevent-scrolling").removeClass("prevent-scrolling");
            $("#side-nav-beds").addClass("side-nav-closed");
            $("#side-nav-beds").removeClass("side-nav-open");
            $("#side-nav-chairs").addClass("side-nav-closed"); 
            $("#side-nav-chairs").removeClass("side-nav-open");
            $("#side-nav-scooters").addClass("side-nav-closed");
            $("#side-nav-scooters").removeClass("side-nav-open");
		}
		else if($("#side-nav-main").hasClass("open-slide")) {
			
		}
	});
});

//Open chairs menu
$(document).ready(function () {
	$("#side-nav-item-chairs").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-chairs").hasClass("side-nav-closed")) {
            $("#side-nav-chairs").addClass("side-nav-open");
            $("#side-nav-chairs").removeClass("side-nav-closed");
		}
		else if($("#side-nav-chairs").hasClass("open-slide")) {
			
		}
	});
});

//Open chairs diff menu
$(document).ready(function () {
	$("#side-nav-item-chairs-diff").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-chairs-diff").hasClass("side-nav-closed")) {
            $("#side-nav-chairs-diff").addClass("side-nav-open");
            $("#side-nav-chairs-diff").removeClass("side-nav-closed");
		}
		else if($("#side-nav-chairs-diff").hasClass("open-slide")) {
			
		}
	});
});

//Close chairs menu
$(document).ready(function () {
	$("#all-departments-chairs").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-chairs").hasClass("side-nav-open")) {
            $("#side-nav-chairs").addClass("side-nav-closed");
            $("#side-nav-chairs").removeClass("side-nav-open");
		}
		else if($("#side-nav-chairs").hasClass("open-slide")) {
			
		}
	});
});
//Close chairs diff menu
$(document).ready(function () {
	$("#all-departments-chairs-diff").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-chairs-diff").hasClass("side-nav-open")) {
            $("#side-nav-chairs-diff").addClass("side-nav-closed");
            $("#side-nav-chairs-diff").removeClass("side-nav-open");
		}
		else if($("#side-nav-chairs-diff").hasClass("open-slide")) {
			
		}
	});
});

//Open beds menu
$(document).ready(function () {
	$("#side-nav-item-beds").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-beds").hasClass("side-nav-closed")) {
            $("#side-nav-beds").addClass("side-nav-open");
            $("#side-nav-beds").removeClass("side-nav-closed");
		}
		else if($("#side-nav-beds").hasClass("open-slide")) {
			
		}
	});
});
//Open beds menu
$(document).ready(function () {
	$("#side-nav-item-beds-diff").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-beds-diff").hasClass("side-nav-closed")) {
            $("#side-nav-beds-diff").addClass("side-nav-open");
            $("#side-nav-beds-diff").removeClass("side-nav-closed");
		}
		else if($("#side-nav-beds-diff").hasClass("open-slide")) {
			
		}
	});
});

//Close beds menu
$(document).ready(function () {
	$("#all-departments-beds").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-beds").hasClass("side-nav-open")) {
            $("#side-nav-beds").addClass("side-nav-closed");
            $("#side-nav-beds").removeClass("side-nav-open");
		}
		else if($("#side-nav-beds").hasClass("open-slide")) {
			
		}
	});
});
//Close beds diff menu
$(document).ready(function () {
	$("#all-departments-beds-diff").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-beds-diff").hasClass("side-nav-open")) {
            $("#side-nav-beds-diff").addClass("side-nav-closed");
            $("#side-nav-beds-diff").removeClass("side-nav-open");
		}
		else if($("#side-nav-beds-diff").hasClass("open-slide")) {
			
		}
	});
});

//Open scooters menu
$(document).ready(function () {
	$("#side-nav-item-scooters").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-scooters").hasClass("side-nav-closed")) {
            $("#side-nav-scooters").addClass("side-nav-open");
            $("#side-nav-scooters").removeClass("side-nav-closed");
		}
		else if($("#side-nav-scooters").hasClass("open-slide")) {
			
		}
	});
});
//Open scooters diff menu
$(document).ready(function () {
	$("#side-nav-item-scooters-diff").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-scooters-diff").hasClass("side-nav-closed")) {
            $("#side-nav-scooters-diff").addClass("side-nav-open");
            $("#side-nav-scooters-diff").removeClass("side-nav-closed");
		}
		else if($("#side-nav-scooters-diff").hasClass("open-slide")) {
			
		}
	});
});

//Close scooters menu
$(document).ready(function () {
	$("#all-departments-scooters").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-scooters").hasClass("side-nav-open")) {
            $("#side-nav-scooters").addClass("side-nav-closed");
            $("#side-nav-scooters").removeClass("side-nav-open");
		}
		else if($("#side-nav-scooters").hasClass("open-slide")) {
			
		}
	});
});
//Close scooters diff menu
$(document).ready(function () {
	$("#all-departments-scooters-diff").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-scooters-diff").hasClass("side-nav-open")) {
            $("#side-nav-scooters-diff").addClass("side-nav-closed");
            $("#side-nav-scooters-diff").removeClass("side-nav-open");
		}
		else if($("#side-nav-scooters-diff").hasClass("open-slide")) {
			
		}
	});
});

//Open More menu
$(document).ready(function () {
	$("#side-nav-item-more").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-more").hasClass("side-nav-closed")) {
            $("#side-nav-more").addClass("side-nav-open");
            $("#side-nav-more").removeClass("side-nav-closed");
		}
		else if($("#side-nav-more").hasClass("open-slide")) {
			
		}
	});
});
//Close more menu
$(document).ready(function () {
	$("#all-departments-more").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-more").hasClass("side-nav-open")) {
            $("#side-nav-more").addClass("side-nav-closed");
            $("#side-nav-more").removeClass("side-nav-open");
		}
		else if($("#side-nav-more").hasClass("open-slide")) {
			
		}
	});
});
// ---------- Showroom Slider ---------- //
//Expand slider on button press 
$(document).ready(function () {
	$("#showroom-slider-button").on("click", function(e){
            e.preventDefault();
            $("#header-desktop-inner-main").addClass("hide-op");
            
            $("#showroom-slider-button").addClass("hide-op");
            setTimeout(function(){
                $('.showroom-slide').css('margin-top', '0');
                $("#header-desktop").addClass("translate-dt-head-up");
                $("#showroom-slider").addClass("translate-dt-head-up");
                $("#showroom-slider").addClass("showroom-slider-open");
                $("#showroom-breadcrumbs").addClass("translate-dt-down");
                $("#showroom-introduction").addClass("translate-dt-down");
                $("#prevent-scrolling").addClass("prevent-scrolling");

            }, 500);
            setTimeout(function(){
                $("#showroom-slider").addClass("showroom-slider-open-arrow");
            }, 1500);
            setTimeout(function(){
                $("#showroom-slider-close").removeClass("hide");
            }, 1700);    
	});
});

//Close slider on close button press
$(document).ready(function () {
	$("#showroom-slider-close").on("click", function(e){
            e.preventDefault();
            $('.showroom-slide').css('margin-top', '-300px');
            $("#showroom-slider").removeClass("showroom-slider-open-arrow");
            $("#showroom-slider-close").addClass("hide");
            $("#showroom-slider").removeClass("showroom-slider-open");
            $("#header-desktop").removeClass("translate-dt-head-up");
            $("#showroom-slider").removeClass("translate-dt-head-up");
            $("#prevent-scrolling").removeClass("prevent-scrolling");
            setTimeout(function(){
                $("#header-desktop-inner-main").removeClass("hide-op");
                $("#showroom-breadcrumbs").removeClass("translate-dt-down");
                $("#showroom-introduction").removeClass("translate-dt-down");
            }, 800);
            setTimeout(function(){
                $("#showroom-slider-button").removeClass("hide-op");
            }, 900);
	});
});

// ---------- Sly Sliders ---------- //
// Store Page
(function () {
    var $frame = $('.showroom-sly-frame');

    // Call Sly on frame
    $frame.sly({
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: 1,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
    });
    // Reload Sly on Resize 
    $(window).resize(function (e) {
        $frame.sly('reload');
    });
}());

// Category Page - Selector
(function () {
    var $frame = $('.category-selector-sly-frame');

    // Call Sly on frame
    $frame.sly({
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: true,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
    });
    // Reload Sly on Resize 
    $(window).resize(function (e) {
        $frame.sly('reload');
    });
}());

// Category Page - Story
(function () {
    var $frame = $('.category-story-sly-frame');

    // Call Sly on frame
    $frame.sly({
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: true,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
    });
    // Reload Sly on Resize 
    $(window).resize(function (e) {
        $frame.sly('reload');
    });
}());

// Scroll to Anchors //

$(".sliding-link").click(function (e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({ scrollTop: $(aid).offset().top }, 'slow');
});


//Product Page Scroll to Reviews //
var element = document.getElementById("tabbed-content-selection");

$("#go-to-reviews").click(function (e) {
    e.preventDefault();
    // $("#tab-overview, #tab-specifications, #tab-delivery, #tab-faqs").removeClass("active");
    // $("#tab-reviews").addClass("active");
    // $("#content-overview, #content-specifications, #content-delivery, #content-faqs").css("display", "none");
    // $("#content-reviews").css("display", "block");
    // const reviews = document.querySelector("#content-reviews");
    let reviews = document.querySelector("#section-reviews-2");
    if(reviews === null || reviews === undefined) {
        reviews = document.querySelector("#section-reviews");
    }
    
    const delToc = document.querySelector('#toc-reviews');
    const delToc2 = document.querySelector('#toc-reviews-2');
    if(delToc2 === null || delToc2.getBoundingClientRect().top === 0) {
        delToc.classList.remove('toc-content-hidden')
    } else {
        delToc2.classList.remove('toc-content-hidden')
    }

    const allTocBtnImg = [...document.querySelectorAll('.toc-btn-img')];

    allTocBtnImg.map(img => {
        if(img.dataset.id === 'toc-reviews') {
            img.src = 'https://cdn.shopify.com/s/files/1/2178/1121/t/42/assets/icon-minus-dropdown.svg'
        }
    })

    reviews.scrollIntoView();
}); 

//Product Page Scroll to Delivery //

$("#go-to-delivery").click(function (e) {
    e.preventDefault();
    $("#tab-overview, #tab-specifications, #tab-reviews, #tab-faqs").removeClass("active");
    $("#tab-delivery").addClass("active");
    $("#tab-content-overview, #tab-content-specifications, #tab-content-reviews, #tab-content-faqs").css("display", "none");
    $("#tab-content-delivery").css("display", "block");
    element.scrollIntoView();
});




// ---------- Advert Code Cookie and Release ---------- //
function setCookie(name, value, days){
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000)); 
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + value + expires + ";path=/";
}

function getParam(p){
    // console.log("find: " + p)
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}


function readCookie(name) { 
  var n = name + "="; 
  var cookie = document.cookie.split(';'); 
  for(var i=0;i < cookie.length;i++) {      
      var c = cookie[i];      
      while (c.charAt(0)==' '){c = c.substring(1,c.length);}      
      if (c.indexOf(n) == 0){return c.substring(n.length,c.length);} 
  } 
  return null; 
 } 

function ref_code2(){
	// Get ref value from param
	var data = getParam('ref');
    // Initially set Ref to param value or default to NET1
    var ref = data !== null && data !== '' ? data : 'NET1'
    // If ref isnt from email then check cookie otherwise overwrite cookie
    if(ref !== 'em1' && ref !== 'EM1' ){
          // If there is a ref code stored in a cookie, set that as ref value
        ref =  readCookie('referenceCode') ? readCookie('referenceCode') : ref
    }
    // Array of associated ad codes
    const ad_codes = ['ADW1', 'Adw1','Bing1', 'BING1', 'Net1','NET1','Fbk1' ,'FBK1','ZOP','EMAIL50CONNECT','FBK3','Em1','EM1','SUB2']
    // If ref value is in ad code array, then turn to lowercase
    ref = ad_codes.includes(ref) ? ref.toLowerCase() : ref;
    // Store ref value in cookie
	setCookie('referenceCode', ref, 90);
    
	return ref;
};
    //     ASSOCIATED AD CODES    //
	// var ad_codes_array = {
	// 	'ADW1':'Google AdWords',
	// 	'BING1':'Bing Adverts',
	// 	'NET1':'Website',
	// 	'FBK1':'Facebook',
	// 	'ZOP':'Chat',
	// 	'EMAIL50CONNECT':'Email 50 Connect',
	// 	'FBK3':'Facebook Remarketing',
	// 	'EM1':'Email Newsletter',
	// 	'SUB2':'Sub2Tech'
	// };

$(document).ready(function(){

    var valToSet = ref_code2();
    $( "input[name='lead_source']" ).each(function( index ) {
        $( this ).val( valToSet );
        // console.log(  "test input by name: " +  $( this ).val());
        // console.log(  "test input by ID: " +  $( "#lead_source_brochure" ).val());
      
    });


});
// END AD CODE SCRIPT

// ---------- Store Cookies and Hide and Show for Phone Numbers ---------- //
var url = window.location.search;
if(url.indexOf('?ref=adw1') !== -1)
    Cookies.set('phone-show', 'adwords', { expires: 5 });

if (Cookies.get("phone-show") == 'adwords')
{
    $("#default-number, #default-number-sticky, #default-number-store, #default-number-mobile, #default-number-product-delivery, #default-number-side-nav, #default-number-express").addClass("nav-number-hide");
    $("#adwords-number, #adwords-number-sticky, #adwords-number-store, #adwords-number-mobile, #adwords-number-product-delivery, #adwords-number-side-nav, #adwords-number-express").removeClass("nav-number-hide");
}

if(url.indexOf('?ref=ADW1') !== -1)
    Cookies.set('phone-show', 'adwords', { expires: 5 });

if (Cookies.get("phone-show") == 'adwords')
{
    $("#default-number, #default-number-sticky, #default-number-store, #default-number-mobile, #default-number-product-delivery, #default-number-side-nav, #default-number-express").addClass("nav-number-hide");
    $("#adwords-number, #adwords-number-sticky, #adwords-number-store, #adwords-number-mobile, #adwords-number-product-delivery, #adwords-number-side-nav, #adwords-number-express").removeClass("nav-number-hide");
}

if(url.indexOf('?ref=bing1') !== -1)
    Cookies.set('phone-show', 'bing', { expires: 5 });
    
if (Cookies.get("phone-show") == 'bing')
{
    $("#default-number, #default-number-sticky, #default-number-store, #default-number-mobile, #default-number-product-delivery, #default-number-side-nav, #default-number-express").addClass("nav-number-hide");
    $("#bing-number, #bing-number-sticky, #bing-number-store, #bing-number-mobile, #bing-number-product-delivery, #bing-number-side-nav, #bing-number-express").removeClass("nav-number-hide");
}

if(url.indexOf('?ref=BING1') !== -1)
    Cookies.set('phone-show', 'bing', { expires: 5 });
    
if (Cookies.get("phone-show") == 'bing')
{
    $("#default-number, #default-number-sticky, #default-number-store, #default-number-mobile, #default-number-product-delivery, #default-number-side-nav, #default-number-express").addClass("nav-number-hide");
    $("#bing-number, #bing-number-sticky, #bing-number-store, #bing-number-mobile, #bing-number-product-delivery, #bing-number-side-nav, #bing-number-express").removeClass("nav-number-hide");
}

// ---------- Local Storage for Bringing in PPC Ad Campaign and PPC Ad Group to Forms ---------- //
// Parse the URL
function getParameterByName( name ) //courtesy Artem
{
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  var regexS = "[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp( regexS );
  var results = regex.exec( window.location.href );
  if( results == null )
    return "";
  else
    return decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Give the URL parameters variable names - Ad Campaign
var ppcCampaignRaw = getParameterByName('campaign');
var ppcCampaign = ppcCampaignRaw;
if (ppcCampaign) {
    localStorage.setItem("ppcCampaignStored", ppcCampaign);
}

var campaignForForms = localStorage.getItem("ppcCampaignStored"); 

// Give the URL parameters variable names - Ad Group
var ppcAdGroupRaw = getParameterByName('adgroup');
var ppcAdGroup = ppcAdGroupRaw;
if (ppcAdGroup) {
    localStorage.setItem("ppcAdGroupStored", ppcAdGroup);
}

var adGroupForForms = localStorage.getItem("ppcAdGroupStored");


$(document).ready(function(){
    $( "input[name='ad_campaign']" ).each(function( index ) {
        $( this ).val( campaignForForms );
        // console.log(  "test ad campaign: " +  $( this ).val());
    });

    $( "input[name='ad_group']" ).each(function( index ) {
        $( this ).val( adGroupForForms );
        // console.log(  "test ad group: " +  $( this ).val());
    });
});
// ---------- END Local Storage for Bringing in PPC Ad Campaign and PPC Ad Group to Forms END ---------- //

// ---------- Comparison Table ---------- //
// DIRTY Responsive pricing table JS
// https://codepen.io/adrianjacob/pen/KdVLXY

$("ul").on("click", "li", function () {
    var pos = $(this).index() + 2;
    $("tr").find('td:not(:eq(0))').hide();
    $('td:nth-child(' + pos + ')').css('display', 'table-cell');
    $("tr").find('th:not(:eq(0))').hide();
    $('li').removeClass('active');
    $(this).addClass('active');
});

// Initialize the media query
var mediaQuery = window.matchMedia('(min-width: 840px)');

// Add a listen event
mediaQuery.addListener(doSomething);

// Function to do something with the media query
function doSomething(mediaQuery) {
    if (mediaQuery.matches) {
        $('.sep').attr('colspan', 4);
    } else {
        $('.sep').attr('colspan', 2);
    }
}
// ---------- Comparison Table End ---------- //


// ---------- Tabbed Content ---------- //
$(document).ready(function () {
    $('.tabbed-content-chairs .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-beds .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-scooter-selection .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-chair-selection .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-delivery .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-product-chair .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-product-scooter .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-product-bed .tab_wrapper').champ();
})

// Add Info to Production Option Selectors & Scroll to Anchors for Help //

function bcpoDone() {
    //Beds
    //Bed Size
    var htmlForBedSize ='<span class="product-option-helper" id="bed-options-size">Learn More<i class="fas fa-question-circle"></i></span>';
    $( "#sales-form-bed > #bcpo > div:first-of-type > .bcpo-label > label").append(htmlForBedSize);

    var specs = document.getElementById("tabbed-content-selection");
    $("#bed-options-size").click(function (e) {
        e.preventDefault();
        $("#tab-overview, #tab-reviews, #tab-delivery, #tab-faqs").removeClass("active");
        $("#tab-specifications").addClass("active");
        $("#tab-content-overview, #tab-content-reviews, #tab-content-delivery, #tab-content-faqs").css("display", "none");
        $("#tab-content-specifications").css("display", "block");
        specs.scrollIntoView();
    });
    
    //Bed Mattress
    var htmlForBedMattress ='<span class="product-option-helper" id="bed-options-mattress">Learn More<i class="fas fa-question-circle"></i></span>';
    $( "#sales-form-bed > #bcpo > div:nth-of-type(3) > .bcpo-label > label").append(htmlForBedMattress);

    var mattress = document.getElementById("spec-mattress");
    $("#bed-options-mattress").click(function (e) {
        e.preventDefault();
        $("#tab-overview, #tab-reviews, #tab-delivery, #tab-faqs").removeClass("active");
        $("#tab-specifications").addClass("active");
        $("#tab-content-overview, #tab-content-reviews, #tab-content-delivery, #tab-content-faqs").css("display", "none");
        $("#tab-content-specifications").css("display", "block");
        mattress.scrollIntoView();
    });

    //Chairs
    //Chair Size
    var htmlForChairSize ='<span class="product-option-helper" id="chair-options-size">Learn More<i class="fas fa-question-circle"></i></span>';
    $( "#sales-form-chair > #bcpo > div:first-of-type > .bcpo-label > label").append(htmlForChairSize);

    var specs = document.getElementById("tabbed-content-selection");
    $("#chair-options-size").click(function (e) {
        e.preventDefault();
        $("#tab-overview, #tab-reviews, #tab-delivery, #tab-faqs").removeClass("active");
        $("#tab-specifications").addClass("active");
        $("#tab-content-overview, #tab-content-reviews, #tab-content-delivery, #tab-content-faqs").css("display", "none");
        $("#tab-content-specifications").css("display", "block");
        specs.scrollIntoView();
    });
    //Chair Fabric
    var htmlForChairFabric ='<span class="product-option-helper" id="chair-options-fabric">Learn More<i class="fas fa-question-circle"></i></span>';
    $( "#sales-form-chair > #bcpo > div:nth-of-type(2) > .bcpo-label > label").append(htmlForChairFabric);

    $("#chair-options-fabric").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-fabrics-chair").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });


    //Chair Motor
    var htmlForChairMotor ='<span class="product-option-helper" id="chair-options-motor">Learn More<i class="fas fa-question-circle"></i></span>';
    $( "#sales-form-chair > #bcpo > div:nth-of-type(3) > .bcpo-label > label").append(htmlForChairMotor);

    var motorAnchor = document.getElementById("motor-spec"); 
    $("#chair-options-motor").click(function (e) {
        e.preventDefault();
        $("#tab-overview, #tab-reviews, #tab-delivery, #tab-faqs").removeClass("active");
        $("#tab-specifications").addClass("active");
        $("#tab-content-overview, #tab-content-reviews, #tab-content-delivery, #tab-content-faqs").css("display", "none");
        $("#tab-content-specifications").css("display", "block");
        motorAnchor.scrollIntoView();
    });
};


// - Product Schematic Switcher - //
$(document).ready(function () { 
    $('#switcher-1').click(function(){
        $('#switcher-1').addClass("active");
        $('#switcher-2').removeClass("active");
        $('#switcher-3').removeClass("active");
        $('#md-1').removeClass("md-hide");
        $('#md-2').addClass("md-hide");
        $('#md-3').addClass("md-hide");
        
    });
    $('#switcher-2').click(function(){
        $('#switcher-2').addClass("active");
        $('#switcher-1').removeClass("active");
        $('#switcher-3').removeClass("active");
        $('#md-2').removeClass("md-hide");
        $('#md-1').addClass("md-hide");
        $('#md-3').addClass("md-hide");
    });
    $('#switcher-3').click(function(){
        $('#switcher-3').addClass("active");
        $('#switcher-1').removeClass("active");
        $('#switcher-2').removeClass("active");
        $('#md-3').removeClass("md-hide");
        $('#md-1').addClass("md-hide");
        $('#md-2').addClass("md-hide");
    });
});

// - Video Pop Ups -- //
$("#scooter-category-lightweight-video").videoPopup({
	showVideoInformations:false
});

$("#chair-category-luxury-video").videoPopup({
	showVideoInformations:false
});

$("#bed-category-luxury-video").videoPopup({
	showVideoInformations:false
});

// ------- Store Form Sticky ------- //
function handleScroll() {
    const formCon = document.querySelector('.store-form');
    const form = document.querySelector('#store-finder-appointment-form');
    if(formCon !== null ){ 
        const formPos = formCon.getBoundingClientRect().top;
        const content = document.querySelector('.store-information');
        if(formPos < 25) {
            form.classList.add('stick');
        } else {
            form.classList.remove('stick');
        }
    }
}
document.addEventListener('scroll', handleScroll );

    const openLightbox = () => {
    document.getElementById("lightbox-store-imgs").style.display = "block";
    }

    const closeLightbox = () => {
    document.getElementById("lightbox-store-imgs").style.display = "none";
    }

    var slideIndex = 1;
    showSlides(slideIndex);

    function plusSlides(n) {
    showSlides(slideIndex += n);
    }

    function currentSlide(n) {
    showSlides(slideIndex = n);
    }

    function showSlides(n) {
        var i;
        var slides = document.getElementsByClassName("img-slide");
        if(slides.length > 0) {
            if (n > slides.length) {slideIndex = 1}
            if (n < 1) {slideIndex = slides.length}
            for (i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            }
            slides[slideIndex-1].style.display = "block";
        }

    }

// ---------- Product FAQ's Show/Hide/Expand ---------- //
function addEventListenerStamped(el, eventName, handler) { 
    if (el.addEventListener) { el.addEventListener(eventName, handler); }
    else { el.attachEvent('on' + eventName, function () { handler.call(el); }); } 
}
addEventListenerStamped(document, 'stamped:questions:loaded', function(e) {

    $("#faqs-for-stamped .stamped-review").click(function(e) {
      var isActive = $(this).hasClass('active');
      $('.active').removeClass('active');
      // Keep class on the faq tab header
      document.getElementById("tab-faqs").classList.add("active");
      if (!isActive) {
        $(this).addClass('active');
      }
    });

});
addEventListenerStamped(document, 'stamped:questions:loaded', function(e) {

    $("#faqs-for-stamped-2 .stamped-review").click(function(e) {
      var isActive = $(this).hasClass('active');
      $('.active').removeClass('active');
      // Keep class on the faq tab header
      document.getElementById("tab-faqs").classList.add("active");
      if (!isActive) {
        $(this).addClass('active');
      }
    });

});

// -- Cabin Car -- //
const toggleccanswer = (questionIndex) => {
    // Get HTML Elements
    const faqs = document.getElementById("cc-faq-list");
    const answer = faqs.getElementsByClassName("cc-answer")[questionIndex];
    const icon = faqs.getElementsByClassName("icon-container")[questionIndex];

    // Toggle classes to show the related answer
    answer.classList.toggle("cc-answer-show");
    icon.children[0].classList.toggle("hide"); // Plus Icon
    icon.children[1].classList.toggle("hide"); // Minus Icon
    
    // Toggle the answers aria-hidden for the accesbility
    if (answer.attributes['aria-hidden'].value == "true") {
        answer.setAttribute('aria-hidden', 'false');
    } else {
        answer.setAttribute('aria-hidden', 'true');
    }
}

// -- Search Results -- //
const sResults = document.querySelector('#snize_results');
if(sResults !== null) {
    sResults.parentElement.classList.add('container-wide');
    sResults.parentElement.previousElementSibling.classList.add('search-results-heading');
}

// -- Bread Crumbs -- //
const breadcrumbBack = document.querySelector('#breadcrumb-back');
const prevLoc = document.referrer
if(breadcrumbBack !== null ) {
  if(prevLoc !== null && prevLoc !== undefined) {
    breadcrumbBack.href = prevLoc;
  } else {
    breadcrumbBack.href = '/'
  }
}

// ---------- Form Redirects ---------- //
$(document).ready(function () {
    $("#main-pop-up-form, #bed-pop-up-form, #chair-pop-up-form, #scooter-pop-up-form, #main-pop-up-form-exit-intent, #landing-category-bed-form, #landing-category-scooter-form, #landing-category-chair-form").on("submit", function (e) {
        e.preventDefault();

        const changeLocation = () => {
            window.location = '/pages/thank-you-brochure';
        }

        const myTimeout = setTimeout(changeLocation, 1600);

    });
});

// ---------- British Made USP tooltip ---------- //
const showBritishTooltip = () => {
    document.querySelector('.british-tooltip').classList.remove('hide');
}
const hideBritishTooltip = () => {
    document.querySelector('.british-tooltip').classList.add('hide');
}

const showUspTooltip = (className) => {
    if(className !== undefined || className !== null) {
        document.querySelector(`.${className}-tooltip`).classList.remove('hide');
    } else {
        document.querySelector('.british-tooltip').classList.remove('hide');
    }
}
const hideUspTooltip = (className) => {
    if(className !== undefined || className !== null) {
        document.querySelector(`.${className}-tooltip`).classList.add('hide');
    } else { 
        document.querySelector('.british-tooltip').classList.add('hide');
    }
}

const readMoreUsp = (index) => {
    const usps = [...document.querySelectorAll('.usp-item')]
    usps.map(usp => {
        if(usp.dataset.index != index) {
            usp.classList.remove('usp-item-showing-more')
        } else {
            usp.classList.toggle('usp-item-showing-more')
            
        }
    })
}

function PrintElem(elem){
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head>');
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById(elem).innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
}

// ---------- Extras Be Last ---------- //
// Remove Bubble popup for standard HTML form validation
// document.querySelector( "form" )
// .addEventListener( "invalid", function( event ) {
//     event.preventDefault();
// }, true );


